// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14n2b","col":"styles_col__1lLVY"};